import {
  statusAutorizacaoEnum,
  statusIsencaoEnum,
  statusLabelsEnum,
  statusPublicacaoEnum,
  PROTOCOLO_STATUS_AGUARDANDO_APROVACAO,
  PROTOCOLO_STATUS_APROVADA,
  PROTOCOLO_STATUS_CRIADO,
  PROTOCOLO_STATUS_EM_ANDAMENTO,
  PROTOCOLO_STATUS_EMITIDO,
} from "./constants";

export function resolverStatusSolicitacao(status) {
  if (typeof status === "string" && status in statusLabelsEnum) {
    return statusLabelsEnum[status];
  }
  return status;
}

export function getStatusPaletteKey(status) {
  const statusNormalizado = resolverStatusSolicitacao(status);
  switch (statusNormalizado) {
    case statusLabelsEnum.APROVADA:
    case statusLabelsEnum.LICENCA_EMITIDA:
    case statusLabelsEnum.LICENCA_ASSINADA:
      return "success";
    case statusLabelsEnum.REJEITADA:
    case statusLabelsEnum.LICENCA_CANCELADA:
      return "error";
    case statusLabelsEnum.ANALISTA_ANALISANDO:
      return "primary";
    case statusLabelsEnum.SOLICITANDO_INFORMACOES:
    case statusLabelsEnum.CORRECAO:
      return "warning";
    case statusLabelsEnum.AGUARDANDO_PAGAMENTO:
    case statusLabelsEnum.PAGAMENTO_EFETUADO:
      return "info";
    case statusLabelsEnum.AGUARDANDO_APROVACAO:
      return "secondary";
    default:
      return "grey";
  }
}

export function getAutorizacaoPaletteKey(status) {
  switch (status) {
    case statusAutorizacaoEnum.APROVADA:
    case statusAutorizacaoEnum.EMITIDA:
      return "success";
    case statusAutorizacaoEnum.REJEITADA:
      return "error";
    case statusAutorizacaoEnum.EM_ANALISE:
      return "info";
    case statusAutorizacaoEnum.SOLICITANDO_INFORMACOES:
    case statusAutorizacaoEnum.AGUARDANDO_ANALISE:
      return "warning";
    default:
      return "grey";
  }
}

export function getIsencaoPaletteKey(status) {
  switch (status) {
    case statusIsencaoEnum.DEFERIDO:
    case statusIsencaoEnum.ASSINADA:
      return "success";
    case statusIsencaoEnum.INDEFERIDO:
      return "error";
    case statusIsencaoEnum.EM_ANALISE:
    case statusIsencaoEnum.PAGAMENTO_EFETUADO:
      return "info";
    case statusIsencaoEnum.AGUARDANDO_PAGAMENTO:
      return "warning";
    case statusIsencaoEnum.AGUARDANDO_ASSINATURA:
      return "secondary";
    default:
      return "grey";
  }
}

export function getPublicacaoPaletteKey(status) {
  switch (status) {
    case statusPublicacaoEnum.PUBLICADA:
      return "success";
    case statusPublicacaoEnum.RECUSADA:
      return "error";
    case statusPublicacaoEnum.PAGAMENTO_EFETUADO:
      return "info";
    case statusPublicacaoEnum.AGUARDANDO_PAGAMENTO:
      return "warning";
    default:
      return "grey";
  }
}

export function getProtocoloPaletteKey(status) {
  switch (status) {
    case PROTOCOLO_STATUS_EMITIDO:
    case PROTOCOLO_STATUS_APROVADA:
      return "success";
    case PROTOCOLO_STATUS_EM_ANDAMENTO:
      return "info";
    case PROTOCOLO_STATUS_AGUARDANDO_APROVACAO:
      return "secondary";
    case PROTOCOLO_STATUS_CRIADO:
    default:
      return "grey";
  }
}

export function getMuiChipColor(paletteKey) {
  return paletteKey === "grey" ? "default" : paletteKey;
}
